import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using React Bootstrap for modals

const ViewLocationModal = ({ show, handleClose, location }) => {
    if (!location) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Location Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>Name:</strong> {location.name}
                </div>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewLocationModal;
